import { cn } from "../lib/utils";

/** The wordmark: `sentientx.` — lowercase, and the period is the one place the vivid
 * brand orange is allowed to be text. Everything else that says "sentientx" says it in
 * this component; nothing writes the name by hand. */
export function SentientXLogo({ className }: { readonly className?: string }) {
  return (
    <span
      aria-label="sentientx"
      role="img"
      className={cn(
        "inline-flex shrink-0 items-baseline font-display text-body font-semibold tracking-tight text-foreground",
        className,
      )}
    >
      sentientx<span className="text-brand">.</span>
    </span>
  );
}
